import Header from './components/Header';
import HeroSection from './components/HeroSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <CarouselSection />
        <UpdatesSection />
        <CardsSection />
        <AppSection />
        <TopicsSection />
        <AboutSection />
        <ContactSection />
        <MediaSection />
        <FeaturesSection />
        <RankingSection />
        <CommentsSection />
        <IndexSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}